import React, { useState } from 'react';
import { StaticImageData } from 'next/image';

import type { Props as LinkProps } from 'Elements/Link';

import {
    Container,
    LinkContainer,
    Heading,
    Button,
    FurtherDetails,
    Inner,
    ImageContainer,
    ImageWrapper,
    Image
} from './Mini.styled';

export interface Props {
    image: {
        src: StaticImageData | string;
        alt?: string;
    };
    link?: LinkProps;
    onClick?: {
        fnc: () => void;
        ariaLabel: string;
    };
    heading?: string | undefined;
    furtherDetails?: string | undefined;
    id: string;
}

const Mini: React.FC<Props> = props => {
    const { image, heading, furtherDetails, link, onClick } = props;
    const [isHovered, setIsHovered] = useState(false);

    return (
        <Container
            {...link}
            label={undefined}
            as={link ? LinkContainer : undefined}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            data-hover={isHovered}
            onClick={onClick ? onClick.fnc : undefined}
        >
            <ImageContainer>
                <ImageWrapper>
                    <Image src={image.src} alt={image.alt || ''} fill />
                </ImageWrapper>
            </ImageContainer>
            <Inner>
                {heading &&
                    (onClick ? (
                        <Heading>
                            <Button onClick={onClick.fnc} aria-label={onClick.ariaLabel}>
                                {heading}
                            </Button>
                        </Heading>
                    ) : (
                        <Heading>{heading}</Heading>
                    ))}
                {furtherDetails && <FurtherDetails>{furtherDetails}</FurtherDetails>}
            </Inner>
        </Container>
    );
};

export default Mini;
